module.exports = __webpack_public_path__ + "static/media/ge.8210444e.svg";